import { call, put, takeLatest } from 'redux-saga/effects';

import supplierSettingsService from 'services/supplierSettingsService';

import {
  addNewEmailNotificationSetting,
  deleteEmailNotificationSetting,
  fetchGroupEmailSettings,
  types,
  updateGroupEmailSettings,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_GROUP_EMAIL_SETTINGS_REQUEST,
    watchUpdateGroupEmailSettings,
  );
  yield takeLatest(
    types.ADD_NEW_EMAIL_NOTIFICATION_SETTING_REQUEST,
    watchAddNewEmailNotificationSetting,
  );
  yield takeLatest(
    types.DELETE_EMAIL_NOTIFICATION_SETTING_REQUEST,
    watchDeleteEmailNotificationSetting,
  );
}

function* watchFetchGroupEmailSettings() {
  try {
    const emailNotificationSettings = yield call(
      supplierSettingsService.getEmailNotificationSettings,
    );
    yield put(
      fetchGroupEmailSettings.success({
        emailNotificationSettings,
      }),
    );
  } catch (error) {
    fetchGroupEmailSettings.error(error);
  }
}

function* watchAddNewEmailNotificationSetting(action) {
  try {
    const { emailNotificationSetting } = action.payload;
    const response = yield call(
      supplierSettingsService.addNewEmailNotificationSetting,
      emailNotificationSetting,
    );
    yield put(
      addNewEmailNotificationSetting.success({
        emailNotificationSetting: response,
      }),
    );
  } catch (error) {
    yield put(addNewEmailNotificationSetting.error(error));
  }
}

function* watchDeleteEmailNotificationSetting(action) {
  try {
    const { emailNotificationSettingId } = action.payload;
    yield call(
      supplierSettingsService.deleteEmailNotificationSetting,
      emailNotificationSettingId,
    );
    const response = yield call(
      supplierSettingsService.getEmailNotificationSettings,
    );
    yield put(
      deleteEmailNotificationSetting.success({
        emailNotificationSettings: response,
      }),
    );
  } catch (error) {
    yield put(deleteEmailNotificationSetting.error(error));
  }
}

function* watchUpdateGroupEmailSettings(action) {
  try {
    const { emailNotificationSettings } = action.payload;
    const { emailNotificationSettings: newEmailNotificationSettings } =
      yield call(
        supplierSettingsService.updateEmailNotificationSettings,
        emailNotificationSettings,
      );
    yield put(
      updateGroupEmailSettings.success({
        emailNotificationSettings: newEmailNotificationSettings,
      }),
    );
  } catch (error) {
    console.error(error);
    yield put(updateGroupEmailSettings.error({ error }));
  }
}

export function* initSaga() {
  yield call(watchFetchGroupEmailSettings);
}
